import { ca } from '@cian/analytics';

export interface ITrackOpenFullGallery {
  newbuildingId?: number;
}

export function trackOpenFullGallery({ newbuildingId }: ITrackOpenFullGallery) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action: 'open_fullscreen_gallery',
    products: [{ id: newbuildingId, offerType: 'JK' }],
    page: {
      extra: {
        seller_type: 'builders',
      },
      siteType: 'desktop',
      pageType: 'ListingCompareJK',
    },
  });
}
